export default "__VITE_ASSET__OSu5bJjm__"